type ApplicationSettings = {
  openIdAuthority: string;
  openIdClientId: string;
  appVersion: string;
  apiBaseUrl: string;
  spectrumProxyBaseUrl: string;
};

const appSettings: ApplicationSettings = {
  openIdAuthority: process.env.VUE_APP_OPEN_ID_AUTHORITY || "",
  openIdClientId: process.env.VUE_APP_OPEN_ID_CLIENTID || "",
  appVersion: process.env.VUE_APP_VERSION || "",
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL || "",
  spectrumProxyBaseUrl: process.env.VUE_APP_SPECTRUM_PROXY_BASE_URL || ""
};

export default appSettings;
